import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { Container, GoldButton } from "@/components/shared";

export default function Article() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <Container className="py-32 text-center">
        <h1 className="font-serif text-3xl text-[#1E1E2F] mb-3">This dispatch could not be found</h1>
        <GoldButton as="link" to="/journal">Back to the journal</GoldButton>
      </Container>
    );
  }
  if (!article) {
    return <div className="py-40 flex justify-center"><Loader2 className="animate-spin text-[#CDA434]" size={32} /></div>;
  }

  return (
    <article>
      <section className="bg-[#1E1E2F] text-[#FFFAF3] border-b border-[#D6D3CB]">
        <Container className="py-16 sm:py-20">
          <div className="max-w-3xl">
            <Link to="/journal" className="inline-flex items-center gap-1 text-[#FFFAF3]/70 hover:text-[#FFFAF3] text-sm mb-6 link-underline">
              <ArrowLeft size={14} /> The journal
            </Link>
            <p className="font-playfair italic text-base text-[#CDA434] mb-4">
              {new Date(article.published_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
            </p>
            <h1 className="font-serif font-bold text-3xl sm:text-5xl leading-tight">{article.title}</h1>
            <p className="font-sans text-lg text-[#FFFAF3]/75 leading-relaxed mt-6">{article.deck}</p>
          </div>
        </Container>
      </section>

      <section className="py-16 sm:py-24">
        <Container>
          <div className="max-w-3xl mx-auto space-y-6 font-sans text-lg text-[#1B2430] leading-relaxed">
            {article.body.split("\n\n").map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </Container>
      </section>
    </article>
  );
}
